import { Component, OnInit } from "@angular/core";
import { MDBModalRef } from "ng-uikit-pro-standard";

@Component({
  selector: "ll-push-notification-gallery",
  templateUrl: "./push-notification-gallery.component.html",
  styleUrls: ["./push-notification-gallery.component.scss"]
})
export class PushNotificationGalleryComponent implements OnInit {
 
  constructor(public modalRef: MDBModalRef) {}
  ngOnInit(): void {}
}
